<template>
    <vx-table class="xl:grid-cols-3-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Organizational Unit</div>
            <div>Team</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
